import { Box, Typography, Container } from "@mui/material";
import offer from "../../assets/offer.png"

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function ServicesOverview() {
  const overviewImage =
  offer
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f9f9ff" }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            gap: 5,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* LEFT - TEXT */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              fontWeight={800}
              sx={{
                mb: 2,
                color: brandBlue,
                fontSize: { xs: "1.8rem", md: "2.3rem" },
              }}
            >
              What We Offer
            </Typography>

            <Box
              sx={{
                width: "70px",
                height: "4px",
                background: brandRed,
                borderRadius: 2,
                mb: 3,
              }}
            />

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                lineHeight: 1.8,
                fontSize: "1.05rem",
              }}
            >
              Our services are built to support industrial, commercial, and<br /> infrastructure projects with complete end-to-end solutions. From<br /> design and engineering to fabrication, installation, and long-term<br /> maintenance, we ensure reliable performance and high-quality<br /> execution.<br /> <br /> Whether it's customized metal fabrication, equipment installation,<br /> project contracting, or on-site technical support, our team<br /> delivers precision-driven services that meet international<br /> standards and exceed client expectations.
            </Typography>
          </Box>

          {/* RIGHT - IMAGE */}
          <Box
            sx={{
              flex: 1,
              borderRadius: 4,
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              display: "flex",
            }}
          >
            <img
              src={overviewImage}
              alt="Services Overview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
